import l10n from '../lang/locallang';
import * as helpers from '../helpers';

export default function powermailDatepicker(type, form, event) {
    const inputDateStart = form.querySelector('#powermail_field_date_datetime');
    const inputDateEnd = form.querySelector('#powermail_field_date_archive');

    const addError = (elem, errorMessage) => {
        const nodeError = elem.parentNode.querySelector('.error');

        const message = errorMessage || ` ${l10n.entryError}`;

        if (!nodeError) {
            const elemId = elem.getAttribute('id');

            if (!elemId) {
                console.error('This field has no id, it is required.');
            } else {
                const alertContainer = document.createElement('div');
                alertContainer.setAttribute('id', `${elemId}-relation`);
                alertContainer.classList.add('error');
                alertContainer.classList.add('parsley-errors-list');

                elem.setAttribute('aria-describedby', `${elemId}-relation`);

                helpers.insertAfter(alertContainer, elem);

                const alertP = document.createElement('p');
                alertP.classList.add('parsley-required');
                alertP.innerHTML = ` ${message}`;
                alertContainer.appendChild(alertP);
            }
        }
    };

    const validDate = () => {
        if (inputDateEnd.value && inputDateStart.value) {
            if (new Date(inputDateEnd.value) >= new Date(inputDateStart.value)) {
                const elemId = inputDateEnd.getAttribute('id');
                const errorBlock = document.querySelector(`#${elemId}-relation`);

                if (errorBlock) {
                    errorBlock.parentElement.removeChild(errorBlock);
                }
                return true;
            }
            addError(inputDateEnd, ` ${l10n.endDateError}`);
            inputDateEnd.focus();
        }
    };

    if (inputDateStart && inputDateEnd) {
        if (event) {
            event.preventDefault();
        }

        if (type === 'change') {
            [inputDateStart, inputDateEnd].forEach((el) => {
                el.addEventListener('change', () => {
                    validDate();
                });
            });
        } else if (type === 'submit') {
            if (validDate()) {
                form.submit();
            }
        } else if (type === 'load') {
            validDate();
        }
    }
}
